import styled from '@emotion/styled';
import querystring from 'qs';
import React, { useState } from 'react';

import { SchemaForm } from './forms/InnerSchemaForm';
import { connectLocation } from './location/LocationConnectors';

const FormContainer = styled.div`
  background-color: #f5f5f5;
  margin-top: 20px;
  transition: all 0.3s ease-in-out;
  overflow: hidden;
  position: relative;

  ${props =>
    props.isExpanded
      ? `
    opacity: 1;
  `
      : `
    max-height: 0;
    opacity: 0;
  `}
`;

const FormContent = styled.div`
  padding: 20px;
`;

const CloseChevron = styled.button`
  position: absolute;
  top: 10px;
  right: 10px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 5px;
  z-index: 10;

  i {
    font-size: 18px;
    color: #666;
    transition: color 0.2s ease;
  }

  &:hover i {
    color: #d40f7d;
  }
`;

const ToggleButton = styled.button`
  background: #d40f7d;
  color: white;
  border: none;
  padding: 8px 16px;
  font-size: 18px;
  font-family: 'OCRoboto', sans-serif;
  font-weight: 400;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  width: auto;
  min-width: 200px;
  max-width: 300px;
  transition: background-color 0.2s ease;

  &:hover {
    background: #b80d6a;
  }

  .indicator {
    margin-left: 10px;
    transition: transform 0.3s ease;

    ${props =>
      props.isExpanded &&
      `
      transform: rotate(180deg);
    `}
  }
`;

const InlineRequestQuoteForm = connectLocation(
  ({
    t,
    locale: { code },
    contractor,
    zip,
    source = 'fac',
    raqFormName = 'request-a-quote-with-toolsey-form',
    buttonText,
    onFormToggle,
  }) => {
    const [isExpanded, setIsExpanded] = useState(true);

    const handleToggle = () => {
      const newExpandedState = !isExpanded;
      setIsExpanded(newExpandedState);

      // Call the optional callback to notify parent component
      if (onFormToggle) {
        onFormToggle(newExpandedState);
      }
    };

    // Build the same parameters as the original modal
    let params = {};
    if (contractor) {
      params = {
        initialWidth: 0,
        parentTitle: typeof document !== 'undefined' ? document.title : '',
        parentUrl: typeof document !== 'undefined' ? document.location.href : '',
        zipcode: zip,
        contractor: contractor.mas_dealer_code,
        contractor_mas_dealer_code: contractor.mas_dealer_code,
        source,
        'meta[data-track-contractor-id]': contractor.mas_dealer_code,
        'meta[data-track-contractor]': contractor.store_name,
        lang: code,
        contractor_store_name: contractor.store_name,
      };
    }

    const query = `?${querystring.stringify(params)}`;

    return (
      <div>
        {!isExpanded && (
          <ToggleButton
            onClick={handleToggle}
            isExpanded={isExpanded}
            data-track="form-start"
            data-track-form-type="lead"
            data-track-form-name="request-a-quote-with-toolsey"
            data-track-contractor={contractor?.store_name}
            data-track-contractor-id={contractor?.mas_dealer_code}
            data-track-professional="contractor"
          >
            {buttonText || t('contractor_profile.request_quote')}
            <span className="indicator">
              <i className="fa fa-chevron-down" style={{ color: 'white' }} />
            </span>
          </ToggleButton>
        )}

        <FormContainer isExpanded={isExpanded}>
          {isExpanded && (
            <CloseChevron onClick={handleToggle}>
              <i className="fa fa-chevron-up" />
            </CloseChevron>
          )}
          <FormContent>
            <SchemaForm
              uid={`www.owenscorning.com/${(code || 'en-US').toLowerCase()}/roofing/${raqFormName}`}
              search={query}
            />
          </FormContent>
        </FormContainer>
      </div>
    );
  }
);

InlineRequestQuoteForm.displayName = 'InlineRequestQuoteForm';

export default InlineRequestQuoteForm;
